import React, { useState, useEffect } from 'react';

import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Area,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
  Progress,
  Loading,
  Empty,
  Summary,
} from '~/components';

import { LoadArea } from './styles';

import ProdutoType from '~/@types/produto';

const Produtos: React.FC = () => {
  const [inLoad, setInLoad] = useState(false);
  const [produtos, setProdutos] = useState<ProdutoType[]>([]);

  const fetchProdutos = async (pStrSearch: string) => {
    try {
      setInLoad(true);

      const response = await api.get(`produtos?busca=${pStrSearch}`);

      const { data } = response;

      if (data && data.length) {
        setProdutos(data);
      }

      setInLoad(false);
    } catch (e) {
      setInLoad(false);
    }
  };

  useEffect(() => {
    fetchProdutos('');
  }, []);

  const gerarRelatorioCSV = () => {
    let data: string[] = [];

    data.push('IDPRODUTO,SKU;NOME;PRECO;ESTOQUE');

    let c;
    for (c in produtos) {
      const produto = produtos[c];
      let v;
      for (v in produto.variacoes) {
        const variacao = produto.variacoes[v];
        data.push(
          `${produto.idproduto};${variacao.sku};${produto.nome} ${variacao.descricao};${produto.preco};${variacao.estoque}`,
        );
      }
    }

    const csv = data.join('\n');

    exportCsv(csv, 'PRODUTOS');
  };

  const gerarRelatorioPDF = () => {
    const cabecalho = ['IDPRODUTO', 'SKU', 'NOME', 'PREÇO', 'ESTOQUE'];

    const data: string[][] = [];

    let c;
    for (c in produtos) {
      const produto = produtos[c];

      let v;
      for (v in produto.variacoes) {
        const linha: string[] = [];
        const variacao = produto.variacoes[v];
        linha.push(produto.idproduto);
        linha.push(variacao.sku);
        linha.push(`${produto.nome} ${variacao.descricao}`);
        linha.push(produto.precoformatado);
        linha.push(variacao.estoque);
        data.push(linha);
      }
    }

    exportPdf(cabecalho, data, 'PRODUTOS');
  };

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Produtos"
            subtitle="Visualize seus produtos de forma rápida"
            isSearch
            onSearch={fetchProdutos}
            placeholder="Buscar em produtos..."
          />

          {produtos.length ? (
            <Summary>
              <h1>
                {produtos.length > 1
                  ? `${produtos.length} produtos encontrados`
                  : 'Um produtos encontrado'}
              </h1>
              <div>
                <button
                  className="excel"
                  onClick={gerarRelatorioCSV}
                  title="Exportar para Excel"
                >
                  <FaFileExcel size={22} color="#fff" />
                  <div>
                    <h3>EXPORTAR</h3>
                    <h2>EXCEL</h2>
                  </div>
                </button>
                <button
                  className="pdf"
                  onClick={gerarRelatorioPDF}
                  title="Exportar para PDF"
                >
                  <FaFilePdf size={22} color="#fff" />
                  <div>
                    <h3>EXPORTAR</h3>
                    <h2>PDF</h2>
                  </div>
                </button>
              </div>
            </Summary>
          ) : null}

          {!inLoad ? (
            <Area>
              {produtos.length ? (
                <Grid>
                  <GridLine>
                    <GridHeadItem title="ID" width={80} />
                    <GridHeadItem title="SKU" width={200} />
                    <GridHeadItem title="Nome" />
                    <GridHeadItem title="Preço" width={160} />
                    <GridHeadItem title="Estoque" width={100} />
                  </GridLine>

                  {produtos.map((produto, key) => {
                    return produto.variacoes.map(variacao => (
                      <GridLine key={produto.idproduto}>
                        <GridItem width={80}>
                          <strong>{produto.idproduto}</strong>
                        </GridItem>
                        <GridItem width={200}>
                          <strong>{variacao.sku}</strong>
                        </GridItem>
                        <GridItem>
                          {produto.nome} {variacao.descricao}
                        </GridItem>
                        <GridItem width={160}>
                          {produto.precoformatado}
                        </GridItem>
                        <GridItem width={100}>{variacao.estoque}</GridItem>
                      </GridLine>
                    ));
                  })}
                </Grid>
              ) : (
                <Empty>Nenhum produto cadastrado.</Empty>
              )}
            </Area>
          ) : (
            <LoadArea>
              <Loading color="#333" size={36} />
            </LoadArea>
          )}
        </Container>
      </Scroll>
    </>
  );
};

export default Produtos;
